export default {
  orderNo: 'No Kargo',
  vehicle: 'Kendaraan',
  vehicleNumber: 'No. Kendaraan',
  driver: 'Sopir',
  lastLocation: 'Lokasi Terakhir',
  status: 'Status',
};
